var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { attrs: { pills: "", card: "", vertical: "" } },
        _vm._l(_vm.params, function (group, idx) {
          return _c(
            "b-tab",
            {
              key: idx,
              attrs: { "title-link-class": "", active: group.is_active },
            },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "fs-lg px-4 text-center" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(group.title) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-card-text",
                [
                  _c(group.component, {
                    tag: "component",
                    attrs: { items: group.items, cur_idx: idx },
                    on: { change_extra: _vm.set_on_change },
                  }),
                ],
                1
              ),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }